import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LAYOUT_FEATURE_KEY, layoutReducer } from './layout.reducer';
import { LayoutEffects } from './layout.effects';
import { LayoutFacade } from './layout.facade';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(LAYOUT_FEATURE_KEY, layoutReducer), EffectsModule.forFeature([LayoutEffects])],
    providers: [LayoutFacade],
})
export class LayoutStoreModule {}
